var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.63 136.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.09,138.73h8.59l.05,8.08h-8.64v45.93h-7.61v-61c0-2.29-.09-5,.63-7a10.31,10.31,0,0,1,2.76-4.29,10,10,0,0,1,3.83-2.6,17.53,17.53,0,0,1,6.34-1.14l4.68.09v7.11a39.78,39.78,0,0,0-5.25.44,6.48,6.48,0,0,0-3.8,2.47,8.92,8.92,0,0,0-1.58,4.88Z",
    transform: "translate(-297.64 -116.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367,138.93v36.93c0,5.87-2.06,8.81-6.27,8.81h-21c-4.21,0-6.27-2.94-6.27-8.81V138.93h-7.59v37.35c0,11,3.9,16.47,11.9,16.47H348.5c.73,0,1.41,0,2.05-.08v0c.46,0,.94.05,1.44.05h10.69c8,0,11.93-5.46,11.93-16.47V138.93Z",
    transform: "translate(-297.64 -116.67)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.28,
    y: 0.09,
    width: 7.63,
    height: 75.98
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.58,
    y: 0.09,
    width: 7.63,
    height: 75.98
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445.07,138.73H422.73v8.17h22.34c5.4,0,7.7,2.9,7.7,9V179.8a5.12,5.12,0,0,1-5.12,5.12H430.09c-4.06,0-7.26-1.48-7.26-7.66,0-6.34,2.65-7.66,7.26-7.66h17.38v-8H430.11c-8.63,0-15.41,5.35-14.93,16.48,0,8.27,5.6,14.68,14.33,14.68h21.32a9.82,9.82,0,0,0,9.82-9.82V155.59C461,144.4,456.26,139.12,445.07,138.73Z",
    transform: "translate(-297.64 -116.67)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.8,215.29H434.4V221h16.4c4,0,5.66,2,5.66,6.31v16.79a3.68,3.68,0,0,1-3.76,3.6H439.8c-3,0-5.33-1-5.33-5.38s1.95-5.37,5.33-5.37h12.77v-5.64H439.82c-6.34,0-11.32,3.76-11,11.57,0,5.81,4.11,10.31,10.52,10.31H455a7.05,7.05,0,0,0,7.21-6.89V227.13C462.49,219.27,459,215.56,450.8,215.29Z",
    transform: "translate(-297.64 -116.67)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.61,215.29h-11a5.8,5.8,0,0,0-4.09,1.44,3.17,3.17,0,0,1-3.84,0,5.59,5.59,0,0,0-3.88-1.28H306c-5,0-8.38,4.05-8.38,9v28.66a.19.19,0,0,0,.19.19h6a.19.19,0,0,0,.19-.19V224.62a3.19,3.19,0,0,1,3.19-3.19h8.93a4,4,0,0,1,3.95,3.94v27.81a.19.19,0,0,0,.19.19h5.2a.23.23,0,0,0,.23-.24l-.43-28.3a3.59,3.59,0,0,1,3.59-3.59h9.29a3.19,3.19,0,0,1,3.19,3.19V253a.19.19,0,0,0,.18.19h6.05a.19.19,0,0,0,.19-.19V224.22C347.81,219.29,344.54,215.29,339.61,215.29Z",
    transform: "translate(-297.64 -116.67)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.49,215.29H362.83a9.21,9.21,0,0,0-9.21,9.21V244a9.21,9.21,0,0,0,9.21,9.21h13.66A9.21,9.21,0,0,0,385.7,244V224.5A9.21,9.21,0,0,0,376.49,215.29Zm3.31,28.25a3.78,3.78,0,0,1-3.78,3.78H363.78a3.78,3.78,0,0,1-3.78-3.78V225.16a3.78,3.78,0,0,1,3.78-3.78H376a3.78,3.78,0,0,1,3.78,3.78Z",
    transform: "translate(-297.64 -116.67)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417,199.08v16.56a9.45,9.45,0,0,0-2.51-.35H400.82a9.21,9.21,0,0,0-9.21,9.21V244a9.21,9.21,0,0,0,9.21,9.21h13.65c5.09,0,8.55-4,8.55-9.13v-45Zm-3,48.24H401.76a3.78,3.78,0,0,1-3.78-3.78V225.16a3.78,3.78,0,0,1,3.78-3.78H414a3.78,3.78,0,0,1,3,1.48v21.2C417,246.15,416.09,247.32,414,247.32Z",
    transform: "translate(-297.64 -116.67)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.53851c25c6a27702242e044b058bede5.svg";
export { ForwardRef as ReactComponent };